import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { passwordExpiredValidator } from '../validators/password-expired.validator';

@Component({
  selector: 'app-password-expired-modal',
  templateUrl: './password-expired-modal.component.html',
  styleUrls: ['./password-expired-modal.component.scss'],
  animations: [
    trigger('modalAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-20px)' }))
      ])
    ])
  ]
})
export class PasswordExpiredModalComponent implements OnInit {
  @Input() isVisible = false;
  @Output() close = new EventEmitter<void>();
  @Output() updatePassword = new EventEmitter<string>();
  @Input() isLoading = false;
  
  // isLoading = false;
  errorMessage = '';

  /* Reactive form */
  form!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      newPassword: ['', [Validators.required, passwordExpiredValidator]],
      confirmPassword: ['', [Validators.required]]
    });

    // Reset al abrir
    if (this.isVisible) this.resetPassword();

    // Limpiar mensaje si el usuario toca algo
    this.form.valueChanges.subscribe(() => (this.errorMessage = ''));
  }

  closeModal(): void {
    this.errorMessage = "";
    this.isVisible = false;
    this.close.emit();
    this.resetPassword();
  }

  update(): void { 
    if (this.form.invalid) {
      this.errorMessage = 'Completa ambos campos.';
      return;
    }

    const { newPassword, confirmPassword } = this.form.value;

    if (newPassword !== confirmPassword) {
      this.errorMessage = 'Las contraseñas no coinciden.';
      return;
    }

    this.updatePassword.emit(newPassword);
  }

  isPasswordComplete(): boolean {
    // aqui va la lógica de contraseñas

    return false;
  }

  private resetPassword(): void {
    this.form.reset();
    this.isLoading = false;
    
    setTimeout(() => {
      const firstInput = document.getElementById('inputNewPassword') as HTMLInputElement;
      if (firstInput) {
        firstInput.focus();
      }
    }, 100);
  }

  // Método para actualizar el estado de carga desde el componente padre
  setLoading(loading: boolean): void {
    this.isLoading = loading;
  }

  // Método para mostrar un mensaje de error desde el componente padre
  setError(message: string): void {
    this.errorMessage = message;
    this.isLoading = false;
  }
}